import { Clapperboard, ScreenShare, Webcam } from 'lucide-react'
import type { WatchSourceRole } from '@/lib/watch/types'

/** What marks a source beside its name (decorative: the name says whose it is): none for a camera on the course. */
const GLYPHS = { programme: Clapperboard, studio: Webcam, screen: ScreenShare } as const

/**
 * A source's glyph, as the strip's tiles and the swap card show it: the Live show's clapperboard, a screen for a host's
 * screen share, a host's webcam for their Studio camera on the canvas (the swap card's label); nothing for a camera on
 * the course.
 */
export function SourceGlyph({ role }: { role: WatchSourceRole }) {
  if (role === 'camera') return null
  const Glyph = GLYPHS[role]
  return <Glyph aria-hidden="true" />
}
